import React from "react";
import Marquee from "react-fast-marquee";
import "../CSS/final.css";
import Dailyhunt from "../Images/News/Dailyhunt.png";
import DD from "../Images/News/DD.png";
import Divya from "../Images/News/divya.png";
import Entrepreneurs from "../Images/News/Entrepreneurs.png";
import F from "../Images/News/F.png";
import Flip from "../Images/News/flip.png";
import Gnews from "../Images/News/Gnews.png";
import Medium from "../Images/News/Medium.png";
import News18 from "../Images/News/News18.png";
import pti from "../Images/News/pti.png";

// Import different logos

const logos = [Dailyhunt, DD, Divya, Entrepreneurs, F, Flip, Gnews, Medium, News18, pti];
const NewsSlider = () => { 
    return (
      <div className="App">
        {/* Marquee Container with Fade Effect */}
        <div className="marquee-container w-[50px]">
          <Marquee play direction="left" speed={75} delay={1}>
            {logos.map((logo, index) => (
              <div key={index} className="image_wrapper">
                <img src={logo} alt={`logo-${index}`} />
              </div>
            ))}
            {logos.map((logo, index) => (
              <div key={index} className="image_wrapper">
                <img src={logo} alt={`logo-${index}`} />
              </div>
            ))}
          </Marquee>
        </div>
      </div>
    );
  };
  
  export default NewsSlider;
  